import { FC, SVGProps } from 'react';

export const PyRangerIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
    <>
        {/* Light Mode */}
        <svg
            width="40"
            height="44"
            viewBox="0 0 40 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="dark:hidden"
            {...props}
        >
            <path
                d="M8.66337 19.3583L8.58974 36.5998C8.58311 36.9164 8.23737 37.1092 7.96153 36.9492L3.1291 34.1019C1.47441 33.1255 0.457435 31.3457 0.464335 29.4249L0.495071 13.2367C0.497498 11.7283 1.31837 10.337 2.63379 9.60615L17.6139 1.26505C18.7776 0.618531 20.194 0.6357 21.3425 1.30981L26.9982 4.64105C27.2698 4.80092 27.2699 5.19679 26.9998 5.35781L11.9471 13.7807C9.96003 14.9476 8.71995 17.0551 8.65921 19.3582L8.66337 19.3583Z"
                fill="#1E293B"
            />
            <path
                d="M39.0051 31.02L39.0391 13.8776C39.042 12.5484 38.3385 11.3169 37.1943 10.6387L31.5386 7.30744C31.2669 7.14757 30.917 7.34026 30.9104 7.65681L30.8368 24.8984C30.7802 27.2016 29.536 29.309 27.5488 30.4758L16.0886 36.8863L15.9968 41.6681L17.3345 42.4587C18.9892 43.4351 21.0389 43.4572 22.7169 42.5256L36.8622 34.6504C38.1819 33.9155 38.9985 32.5283 39.0009 31.0199L39.0051 31.02Z"
                fill="#1E293B"
            />
            <path
                d="M16.2886 27.7353L16.4666 19.2383C16.4676 18.7925 16.7096 18.3809 17.1017 18.1641L23.7215 14.4607C24.0039 14.3041 24.3537 14.5156 24.3427 14.8404L24.1644 23.3541C24.1508 23.8038 23.8965 24.2069 23.4963 24.4152L16.9016 28.1107C16.6235 28.2591 16.2862 28.052 16.2928 27.7354L16.2886 27.7353Z"
                fill="#1E293B"
            />
        </svg>
        {/* Dark Mode */}
        <svg
            width="40"
            height="44"
            viewBox="0 0 40 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="hidden dark:block"
            {...props}
        >
            <g id="Group 21">
                <path
                    id="Vector"
                    d="M8.95243 19.7279L8.8788 36.9695C8.87217 37.286 8.52644 37.4788 8.2506 37.3188L3.41816 34.4716C1.76347 33.4951 0.746498 31.7154 0.753398 29.7945L0.784133 13.6063C0.786561 12.0979 1.60744 10.7066 2.92286 9.97578L17.903 1.63468C19.0666 0.98816 20.4831 1.00533 21.6315 1.67944L27.2872 5.01068C27.5589 5.17055 27.5589 5.56642 27.2889 5.72744L12.2362 14.1504C10.2491 15.3172 9.00901 17.4247 8.94827 19.7278L8.95243 19.7279Z"
                    fill="#EFF6FF"
                />
                <path
                    id="Vector_2"
                    d="M39.2941 31.3896L39.3282 14.2472C39.331 12.918 38.6276 11.6865 37.4834 11.0083L31.8277 7.67707C31.556 7.5172 31.2061 7.70989 31.1995 8.02644L31.1258 25.268C31.0693 27.5712 29.825 29.6786 27.8379 30.8455L16.3777 37.256L16.2858 42.0378L17.6236 42.8284C19.2783 43.8048 21.328 43.8269 23.006 42.8953L37.1513 35.02C38.4709 34.2851 39.2876 32.8979 39.29 31.3895L39.2941 31.3896Z"
                    fill="#EFF6FF"
                />
                <path
                    id="Vector_3"
                    d="M16.5777 28.1055L16.7557 19.6085C16.7567 19.1626 16.9986 18.751 17.3907 18.5342L24.0105 14.8309C24.293 14.6743 24.6428 14.8858 24.6318 15.2106L24.4534 23.7242C24.4399 24.174 24.1856 24.577 23.7853 24.7853L17.1907 28.4808C16.9126 28.6292 16.5752 28.4221 16.5818 28.1055L16.5777 28.1055Z"
                    fill="#EFF6FF"
                />
            </g>
        </svg>
    </>
);
